import apiFetch from '../apiFetch'

export default function (userId, body, token) {
  return apiFetch({ endPoint: 'user/' + userId, method: 'PUT', body: body, token: token })
}
